import CoursesPage from "./Courses";
const Courses = () => {
  return <CoursesPage />;
};
export default Courses;
